import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/Breadcrum";
import "./Contact.css";
import ContactForm from "../../components/ContactForm/ContactForm";

const Contact = () => {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
return (
    <>
      <Breadcrumb
        title="Contact Us"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      
      ></Breadcrumb>

      <ContactForm />
    </>
  );
};

export default Contact;
